import { useContext } from 'react';

import { OperationContext } from './OperationContext';

export const useOperationContext = () => {
  const context = useContext(OperationContext);
  if (!context) {
    throw new Error(
      'useOperationContext must be used within an OperationProvider'
    );
  }
  return context;
};
